(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enabled = !document.body.classList.contains('no-motion') && !reduced;

  if (enabled && 'IntersectionObserver' in window) {
    document.body.classList.add('js-motion');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });

    // Rete di sicurezza: se dopo 1,2s qualcosa non è mai entrato in viewport
    // (tab nascosta, observer che non scatta), lo mostriamo comunque.
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) {
        var box = el.getBoundingClientRect();
        if (box.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 1200);
  }

  // Header che si condensa allo scroll. Nessuno spostamento di layout:
  // cambiano solo padding e ombra, l'altezza è gestita da una transizione.
  var header = document.querySelector('[data-header]');
  if (header) {
    var last = 0;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-condensed', y > 80);
      last = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Menu mobile e megamenu: aperti/chiusi via stato, mai via :focus-within,
  // altrimenti restano aperti dopo il click sulla voce.
  document.querySelectorAll('[data-toggle]').forEach(function (button) {
    var target = document.getElementById(button.getAttribute('data-toggle'));
    if (!target) return;
    button.addEventListener('click', function () {
      var toggleId = button.getAttribute('data-toggle');
      var isMegamenu = toggleId.indexOf('sub-') === 0;

      // Se apriamo un megamenu, chiudiamo tutti gli altri
      if (isMegamenu && !target.classList.contains('is-open')) {
        document.querySelectorAll('[data-toggle^="sub-"]').forEach(function (otherButton) {
          if (otherButton === button) return;
          var otherTarget = document.getElementById(otherButton.getAttribute('data-toggle'));
          if (otherTarget && otherTarget.classList.contains('is-open')) {
            otherTarget.classList.remove('is-open');
            otherButton.setAttribute('aria-expanded', 'false');
          }
        });
      }

      var open = target.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.is-open[data-dismiss-outside]').forEach(function (el) {
      if (el.contains(event.target)) return;
      var trigger = document.querySelector('[data-toggle="' + el.id + '"]');
      if (trigger && trigger.contains(event.target)) return;
      el.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
  });
})();
